import { createSelector } from 'reselect';
import { error } from '@logger';
import { EXTERNAL } from '@commons/utils/payment/paymentGatewayTypeConstants';
import { providersKeys } from '@commons/config/externalPaymentProvider';
import getShopOnlinePaymentMethods from './getShopOnlinePaymentMethods';
import getPaymentGatewayTypeByCountry from './getPaymentGatewayTypeByCountry';

const getProvider = payentMethod =>
  payentMethod?.paymentProvider === providersKeys.plexo &&
  payentMethod?.uiType === providersKeys.creditel
    ? payentMethod.uiType
    : payentMethod?.paymentProvider;

const getExternalProviderFromStore = externalOnlineProviders => {
  if (externalOnlineProviders?.length) {
    try {
      const paymentProviders = externalOnlineProviders.reduce((result, p) => {
        const provider = getProvider(p);
        return result.includes(provider) ? result : [...result, provider];
      }, []);
      const onlineOptions = externalOnlineProviders.reduce(
        (partialCollection, onlineOption) => [
          ...partialCollection,
          ...onlineOption.onlineOptions,
        ],
        [],
      );

      return { id: EXTERNAL, paymentProviders, onlineOptions };
    } catch (err) {
      error(
        `[Payments][Selectors] getExternalProviderFromStore,
         externalOnlineProviders: ${JSON.stringify(externalOnlineProviders)},
         error: ${err}`,
      );
    }
  }
  return null;
};

export const getPaymentMethod = createSelector(
  getShopOnlinePaymentMethods,
  getPaymentGatewayTypeByCountry,
  (onlinePaymentMethods, type) => {
    if (type !== EXTERNAL)
      return onlinePaymentMethods.find(x => x.paymentProvider === type);
    return getExternalProviderFromStore(onlinePaymentMethods);
  },
);

export default getPaymentMethod;
